export default __webpack_public_path__ + "static/media/sharon_home.52eb49cd.jpg";